let $scroll;

// let transitionFinished = setInterval(() => {

//   if (globalStorage.transitionFinished === true) {

//     clearInterval(transitionFinished);

//     $scroll = new ScrollBasedAnims({ preventTouch: false });

//     // prepPageButtons();
//     // prepDropdowns();
//     // prepDrawers();
//     // prepCollectionBlocks();
//     // prepKlarnaCallouts();

//     document.querySelectorAll(".grid-filter-wrapper").forEach(el => { new GridFilter(el); });
//     // document.querySelectorAll(".item.is-wallpaper").forEach(el => { new wallpaperItem(el); });
//     // document.querySelectorAll(".full-width-slider").forEach(el => { new FullWidthSlider(el); });
//     // document.querySelectorAll(".image-slider").forEach(el => { new FullWidthSlider(el); });
//     // document.querySelectorAll(".quote-slider").forEach(el => { new QuoteSlider(el); });
//     // document.querySelectorAll(".insta-callout").forEach(el => {
//     //   socialCarousel();
//     // })

//     if (globalStorage.glideInits && globalStorage.glideInits.length > 0) {

//       Array.prototype.slice.call(globalStorage.glideInits).forEach((g) => {
//         g.mount();
//       });

//       $scroll.resize();
//     }

//     pageEntrance(namespace);
//   }

// }, 20);